import { faro } from '@grafana/faro-react';

export const logRecaptchaScriptLoadError = (version, error, siteKey) => {
  faro.api.pushLog(['reCAPTCHA script failed to load'], {
    level: 'error',
    context: {
      version,
      error: error.message || String(error),
      siteKeyPrefix: siteKey?.substring(0, 10) + '...',
    },
  });
};

export const logRecaptchaExecuteError = (action, error) => {
  faro.api.pushLog(['reCAPTCHA v3 execute failed'], {
    level: 'error',
    context: {
      action,
      error: error.message || String(error),
      version: 'score',
    },
  });
};

export const logRecaptchaChallengeSuccess = () => {
  faro.api.pushLog(['reCAPTCHA challenge account successful'], {
    level: 'info',
    context: {
      type: 'MFA_challenge',
      version: 'score',
    },
  });
};

export const logRecaptchaChallengeError = (error, originalError) => {
  faro.api.pushLog(['reCAPTCHA challenge account failed'], {
    level: 'error',
    context: {
      type: 'MFA_challenge',
      version: 'score',
      error: error.detail || String(error),
      status: error.status,
      originalError: originalError?.message || String(originalError),
    },
  });
};
